import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface DocumentPreviewProps {
    open: boolean;
    onClose: () => void;
    file: File;
}

const DocumentPreview: React.FC<DocumentPreviewProps> = ({ open, onClose, file }) => {
    const [previewUrl, setPreviewUrl] = useState<string>('');
    const [isPDF, setIsPDF] = useState(false);

    useEffect(() => {
        if (file) {
            const url = URL.createObjectURL(file);
            setPreviewUrl(url);
            setIsPDF(file.type === 'application/pdf');

            return () => {
                URL.revokeObjectURL(url);
            };
        }
    }, [file]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth='lg'
            fullWidth
            PaperProps={{
                sx: {
                    height: '80vh',
                    maxHeight: '80vh',
                    bgcolor: '#fff',
                    borderRadius: '16px',
                },
            }}
        >
            <DialogTitle
                sx={{
                    m: 0,
                    p: 2,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #E3E2E2',
                }}
            >
                <Typography
                    sx={{
                        color: '#132F5F',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '18px',
                        fontWeight: 600,
                    }}
                >
                    {file?.name}
                </Typography>
                <IconButton
                    aria-label='close'
                    onClick={onClose}
                    sx={{
                        color: '#49454F',
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent
                sx={{
                    p: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {isPDF ? (
                    <iframe
                        src={`${previewUrl}#toolbar=0`}
                        width='100%'
                        height='100%'
                        style={{ border: 'none' }}
                        title='PDF Preview'
                    />
                ) : (
                    <Box
                        component='img'
                        src={previewUrl}
                        alt={file?.name}
                        sx={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain',
                        }}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
};

export default DocumentPreview;
